import fr from 'facet-rest';
import { metaOverrideSet as DefaultStepMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultStep';
import DateOrMonthPicker from 'Components/ComponentLibrary/Molecules/DateOrMonthPicker';

export default fr.metaOverride({ base: DefaultStepMetaOverrideSet })
  .nameOverride('targetDate', {
    _component: () => DateOrMonthPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  });
